<template>
  <div>
    <XIASearchBar :searchData="searchData" @search="search" @daochu="search(true)"></XIASearchBar>
    <div class="title">以租代购列表</div>
    <TableComponent :headers="headers" :tableObjet="tableObjet" :height="750">
      <template #time="item">
        <el-tag>{{ item.row.time }}/{{item.row.need_time}}天</el-tag>
      </template>
      <template #zd="item">
        <el-tag>{{ getState(item.row.zd) }}</el-tag>
      </template>
    </TableComponent>
  </div>
</template>
<script setup>
import TableComponent from "@/components/TableComponent.vue";
import XIASearchBar from "@/components/XIA-SearchBar.vue";
import { useYzdg } from "@/use/order";
import { ref } from "vue";
import { ElMessage } from "element-plus";

const { searchData, headers, tableObjet, search } = useYzdg();
const order = ref({});

const showTKModel = ref(false);

const pass = ref();
const amount = ref();
const getState = (i) => {
  const states = [
    "进行中",
    "已失效",
    "已完成",
   
    
  ];
  return states[i];
};
</script>
<style lang="scss" scoped>
.state3 {
  color: #f00;
  font-weight: bold;
}

.state4 {
  color: #0c0;
  font-weight: bold;
}

.state2 {
  color: rgb(84, 84, 229);
  font-weight: bold;
}
.state5 {
  color: #999;
}
.dddd {
  .flex {
    align-items: center;
    height: 40px;

    span {
      margin-left: 35%;
      width: 100px;
    }
  }
}
</style>
